import { memo, useMemo } from 'react';
import { Tabs } from 'react-aria-components';

import { ComponentStack, Flex, Tab, TabList, TabPanel } from '@/components/core';
import { ModelPanelHeader } from '@/components/flow';
import { toModelId, useSuspenseGetModel } from '@/hooks/api';
import { ModelConfigProvider } from '@/store';
import { convertToState } from '@/utils';

import { ModelSettings } from './ModelSettings';
import { Setup } from './Setup';

export type ModelPanelProps = {
  agentId: string;
  modelId: string;
};

const IModelPanel = ({ modelId }: ModelPanelProps) => {
  const { data: model } = useSuspenseGetModel(toModelId(modelId));

  const fields = useMemo(() => convertToState(model.fieldConfig), [model.fieldConfig]);
  const metadata = model.metadata;
  const preprocessConfig = model.preprocessConfig;
  const postprocessConfig = model.postprocessConfig;

  return (
    <ModelConfigProvider
      fields={fields}
      metadata={metadata}
      preprocessConfig={preprocessConfig}
      postprocessConfig={postprocessConfig}
    >
      <Flex col className="w-full">
        <ModelPanelHeader className="border-b border-gray-200 p-4" modelId={modelId} />

        <Flex col className="grow">
          <ComponentStack>
            <Tabs className="group/model-panel">
              <TabList>
                <Tab className="grow justify-center" id="setup">
                  Setup
                </Tab>

                <Tab className="grow justify-center" id="advanced">
                  Advanced
                </Tab>
              </TabList>

              <Flex col className="px-sm">
                <TabPanel id="setup">
                  <Setup />
                </TabPanel>

                <TabPanel id="advanced">
                  <ModelSettings />
                </TabPanel>
              </Flex>
            </Tabs>
          </ComponentStack>
        </Flex>
      </Flex>
    </ModelConfigProvider>
  );
};

export const ModelPanel = memo(IModelPanel) as typeof IModelPanel;
